import { render, staticRenderFns } from "./AccountManual.vue?vue&type=template&id=c5fb29ea&scoped=true&"
import script from "./AccountManual.vue?vue&type=script&lang=js&"
export * from "./AccountManual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5fb29ea",
  null
  
)

export default component.exports